<template>
    <div v-if="config" :key="refreshKey" class="w-full">
        <setting-card
            v-bind="binds"
            v-model:active="config.mailCollect"
            :dialogBind="dialogBind"
            :hideMoreVert="true"
            :hidePrevious="true"
            @updateProfile="updateProfile()"
        >
            <v-row
                v-if="!config.mailCollectKey"
                no-gutters
                class="d-flex align-center justify-center pb-2"
                style="min-width: 650px"
            >
                <v-col cols="5" class="d-flex align-center justify-center">
                    <v-btn
                        rounded
                        @click="generateMailCollectKey()"
                        :disabled="config.mailCollectKey ? true : false"
                    >
                        Générer un identifiant
                    </v-btn>
                </v-col>
            </v-row>
            <template v-else>
                <v-row no-gutters class="d-flex align-center">
                    <v-col cols="12">
                        <v-text-field-filled
                            v-model="config.mailCollectKey"
                            label="Identifiant de collecte des mails"
                            outlined
                            hide-details
                            readonly
                            disabled
                            density="compact"
                        />
                    </v-col>
                </v-row>

                <!-- Email fields with corrected icon alignment and hover effect -->
                <v-row
                    v-for="(email, index) in emailTemplates"
                    :key="index"
                    no-gutters
                    class="d-flex align-center mt-4"
                    style="min-width: 850px"
                >
                    <v-col cols="12">
                        <v-text-field-filled
                            outlined
                            hide-details
                            readonly
                            :label="getEmailLabel(email, index)"
                            @click="copyToClipboard(email, index)"
                            :model-value="email"
                            density="compact"
                            class="pointer_text_field"
                            :append-inner-icon="copied[index] ? '$fa-check' : '$fa-copy'"
                        />
                    </v-col>
                </v-row>
            </template>
        </setting-card>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import { generateRandomString } from "../../../services/mailServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        SettingCard,
    },
    emits: ["updateProfile", "onUpdate"],
})
export class SettingBobbeeCollect extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: null }) companyId!: string;
    @Prop({ default: null }) profileId!: string;
    @Prop({ default: false }) forMyCompany: boolean;

    refreshKey = 0;
    copied = []; // Array to track copied status for each button

    get binds() {
        return {
            title: "Récupération automatique des documents via bobbee",
            partnerName: "bobbee",
            text: "Récupération des documents via bobbee",
        };
    }

    get dialogBind() {
        return {
            title: "Récupération des documents via bobbee",
            "valid-title": "Valider",
            validDisabled: !this.config.mailCollectKey,
        };
    }

    get emailTemplates() {
        const key = this.config.mailCollectKey;
        if (!key) return [];

        return [
            `collect+${key}@bobbee.co`,
            `collect+achat+${key}@bobbee.co`,
            `collect+achats+${key}@bobbee.co`,
            `collect+vente+${key}@bobbee.co`,
            `collect+ventes+${key}@bobbee.co`,
            `collect+divers+${key}@bobbee.co`,
        ];
    }

    // Function to determine the label based on the email content
    getEmailLabel(email: string, index: number) {
        if (index === 0) {
            return "Mail de collecte global";
        } else if (email.includes("achat")) {
            return email.includes("achats") ? "Mail de collecte achats" : "Mail de collecte achat";
        } else if (email.includes("vente")) {
            return email.includes("ventes") ? "Mail de collecte ventes" : "Mail de collecte vente";
        } else if (email.includes("divers")) {
            return "Mail de collecte divers";
        } else {
            return "Mail de collecte";
        }
    }

    updateProfile() {
        if (this.config.mailCollectKey) {
            this.config.mailCollect = true;
        } else {
            this.config.mailCollect = false;
        }
        this.$emit("updateProfile");
    }

    resetDialog() {
        this.refreshKey++;
    }

    refresh() {
        this.$emit("onUpdate");
    }

    generateRandomString() {
        return generateRandomString();
    }

    generateMailCollectKey() {
        if (!this.config.mailCollectKey) {
            this.config.mailCollectKey = this.generateRandomString();
        }
    }

    copyToClipboard(text: string, index: number) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                // this.$set(this.copied, index, true)
                this.copied[index] = true;

                setTimeout(() => {
                    // this.$set(this.copied, index, false)
                    this.copied[index] = false;
                }, 500);
            })
            .catch((err) => {
                console.error("Erreur lors de la copie dans le presse-papiers:", err);
            });
    }
}

export default toNative(SettingBobbeeCollect);
</script>

<style scoped>
.icon-clickable {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.3s ease;
}

:deep(.pointer_text_field input) {
    cursor: pointer;
}
:deep(.v-field__append-inner) {
    color: #f9b12a;
    cursor: pointer;
}
</style>
